import React from "react";
import PropTypes from "prop-types";

import ExpandableListItem from "./ExpandableListItem";

export default class ExpandableList extends React.Component {
  state = { clickedID: undefined };

  closeOnUnfocus = event => {
    // If user clicks inside an expandable element show it, otherwise hide
    let clickedElement = event.target.closest(".expandable-container");
    if (clickedElement) {
      if (clickedElement.querySelector(".expanded") != null) {
        this.setState({ clickedID: undefined });
      } else {
        this.setState({ clickedID: clickedElement.id });
      }
    } else this.setState({ clickedID: undefined });
  };

  componentDidMount() {
    document.addEventListener("click", this.closeOnUnfocus);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.closeOnUnfocus);
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        {this.props.packageList &&
          this.props.packageList.map((pkg, index) => {
            return (
              <ExpandableListItem
                expanded={
                  this.state.clickedID &&
                  this.state.clickedID.indexOf(pkg.id) !== -1
                }
                key={index}
                uniqueID={pkg.id}
                date={pkg.deliveryDate}
                name={pkg.name}
                location={pkg.location}
                unlockID={pkg.unlockID}
              />
            );
          })}
      </div>
    );
  }
}

ExpandableList.propTypes = {
  packageList: PropTypes.array
};
